import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-upairy-timeline.js';

const DEFAULT_IMAGE = 'https://cdn.skyfastimg.com/images/2026/08/04/image-6a71b36bca9e6ff766d8e84d.webp?w=1000';

const defaultItems = [
  {
    content: `<p><span style="color:hsl( 0, 0%, 40% );">Day 1-3</span></p><h2><span style="color:hsl(135,61%,31%);"><strong>Learning Begins</strong></span></h2><p>Your toddler starts to recognise their accidents and learns what that feeling means.</p>`,
  },
  {
    content: `<p><span style="color:hsl(0,0%,40%);">Week 1</span></p><h2><span style="color:hsl(135,61%,31%);"><strong>Connection Forms</strong></span></h2><p>They're telling you about accidents, they become less frequent.</p>`,
  },
  {
    content: ` <p><span style="color:hsl(0,0%,40%);">Week 2+</span></p><h2><span style="color:hsl(135,61%,31%);"><strong>Fully Trained</strong></span></h2><p>Asking before going. Staying dry anywhere. Out of diapers for good. No accidents feared. Complete potty independence</p>`,
  },
];

const renderItem = item => `
  <article class="upairy-timeline__item" data-attribute="upairy-timeline__item">
    <div class="upairy-timeline__marker" aria-hidden="true"></div>
    <div class="upairy-timeline__item-content" data-attribute="upairy-timeline__item-content">
      ${item.content}
    </div>
  </article>
`;

const contentHtml = `
  <div
    class="upairy-timeline container"
    data-attribute="upairy-timeline"
    data-image-position="right"
    data-image-show="true"
    data-line-color="#23873D"
    data-line-width="2"
    style="--line-color: #23873d; --line-width: 2px"
  >
    <header
      class="upairy-timeline__header"
      data-attribute="upairy-timeline__header"
    >
      <h2 style="text-align: center">
        <span style="font-size: 32px"><strong>How It Works:&nbsp;</strong></span>
      </h2>
      <h2 style="text-align: center"><strong>3 Simple Stages*</strong></h2>
    </header>
    <div
      class="upairy-timeline__content"
      data-attribute="upairy-timeline__content"
    >
      <div class="upairy-timeline__list" data-attribute="upairy-timeline__list">
        ${defaultItems.map(renderItem).join('')}
      </div>
      <div class="upairy-timeline__image" data-attribute="upairy-timeline__image">
        <img
          loading="lazy"
          data-attribute="upairy-timeline__image-element"
          src="${DEFAULT_IMAGE}"
          alt="Potty training progress"
        />
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, { backgroundColor: '#D7E8C9', textColor: '#000000' });
